export const LOCALES = {
    ENGLISH: 'en-us',
    JAPANESE: 'ja-jp',
};

export const ACCESSRIGHTS = {
    Read: 1,
    Write: 2,
    Delete: 3,
    Import: 4,
    Export: 5,
    Verify: 6,
    Approve: 7
};

export const ACCESSRIGHTSTYPE = {
    None: 0,
    No: 1,
    Yes: 2
};

export const PAGEID = {
    Vfasp: 1,
    Tranche: 2,
    AgathaConfig: 3,
    Supervisor: 4,
    ExchangeRate: 5,
    IssuerConfig: 6,
    Admin: 11,
    AdminLogin: 12,
    AdminActionLog: 13,
    User: 14,
    UserDetails: 15,
    UserChangeRequest: 16,
    UserLogin: 17,
    UserBalance: 18,
    Promoter: 19,
    CommissionRate: 20,
    Deposit: 21,
    DepositImport: 22,
    Withdraw: 23,
    CashTransaction: 24,
    Transaction: 25,
    Execution: 26,
    TransactionSettlement: 27,
    UserInfoRequest: 28,
    CancelRefund: 29,
    OtcSell: 30,
    UserBlockList: 31,
    VfaspAccessRights: 91,
    DefaultAdminAccessRights: 92,
    AdminAccessRights: 93
};

export const PAGELABEL = {
    1: 'Menu-ClientList',
    2: 'Menu-TrancheList',
    3: 'Menu-AgathaConfiguration',
    4: 'Menu-SupervisorList',
    5: 'Menu-ExchangeRate',
    6: 'Menu-IssuerConfiguration',
    11: 'Menu-SupervisorList',
    12: 'Menu-SupervisorLoginList',
    13: 'Menu-SupervisorActionLogList',
    14: 'Menu-UserList',
    15: 'Menu-UserDetailsList',
    16: 'Menu-UserChangeRequestList',
    17: 'Menu-UserLoginList',
    18: 'Menu-UserBalanceList',
    19: 'Menu-PromoterList',
    20: 'Menu-CommissionRate',
    21: 'Menu-DepositList',
    22: 'Menu-DepositImport',
    23: 'Menu-WithdrawList',
    24: 'Menu-DepositWithdrawList',
    25: 'Menu-TransactionList',
    26: 'Menu-ExecutionList',
    27: 'Menu-SettlementTransactionList',
    28: 'Menu-UserInfoRequestList',
    29: 'Menu-CancelRefundList',
    30: 'Menu-OtcSell',
    31: 'Menu-UserBlockList',
    91: 'Menu-CASPAccessRights',    
    92: 'Menu-DefaultAccessRights',
    93: 'Menu-AdminAccessRights'
};